var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg404TrailHead(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.91593 14.2958C-1.41004 24.4576 4.13788 35.4042 14.2997 38.7301C24.4615 42.0561 35.408 36.5082 38.734 26.3464C42.06 16.1846 36.5121 5.23801 26.3503 1.91205C16.1885 -1.41392 5.24189 4.134 1.91593 14.2958ZM24.3534 13.1814L24.3788 16.7157C24.3841 17.6957 24.8423 18.5998 25.6295 19.1835L28.4648 21.2936C30.9125 23.0935 29.592 26.9413 26.5719 26.8903L13.8361 26.6962C11.306 26.6426 9.88184 23.8326 11.3225 21.7973L18.7022 11.3929C20.4652 8.93316 24.3431 10.1617 24.3534 13.1814Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404TrailHead);
export default __webpack_public_path__ + "static/media/404-trail-head.6845efae91d6a93fcf2cbaa597471461.svg";
export { ForwardRef as ReactComponent };